import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import React from "react";

const Body = styled(Box)(({ theme }) => ({
  width: "100%",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
}));

const UserSection = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "start",
  gap: "12px",
  alignItems:"center",
}));

const DetailSection = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "start",
  justifyContent: "start",
  gap: "7px",
}));

const NameSection = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "start",
  gap: "20px",
}));

export const PriceSection = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "end",
  gap:"7px",
}));

const NameText = styled(Typography)(({ theme }) => ({
  fontSize: "16px",
  color: "#ffffff",
  fontWeight: "500",
}));

const DateText = styled(NameText)(({ theme }) => ({
  fontWeight: "initial",
  color: "#c1c1c1",
  fontSize: "13px",
}));


interface winnerListsProps {
  name: string;
  date?: string;
  ethPrice: string;
  price: string;
}
const WinnerLists: React.FC<winnerListsProps> = ({ name, date,ethPrice, price }) => {
  const user0 = require("assets/Profile/buku_default_avatar.png");
  return (
    <Body>
      <UserSection>
        <img
          src={user0}
          style={{ width: "41px", height: "41px" }}
          alt={"user"}
        />
        <DetailSection>
          <NameSection>
            <NameText>{name}</NameText>
          </NameSection>
          <DateText>{date}</DateText>
        </DetailSection>
      </UserSection>
      <PriceSection>
        <NameSection>
          <NameText>{ethPrice}</NameText>
        </NameSection>
        <DateText>{price}</DateText>
      </PriceSection>
    </Body>
  );
};

export default WinnerLists;
